'use client';

import type { ReactNode } from 'react';
import { SseClientRenderer } from '../../ToolCallsRenderers/renderers/SseClientRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderSseClientResult = (ctx: OutputRenderContext): ReactNode => {
  const { content } = ctx;

  return <SseClientRenderer data={content} />;
};
